function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 0C7.836 0 0 7.836 0 17.5S7.836 35 17.5 35 35 27.164 35 17.5 27.164 0 17.5 0zm7.99 13.645c.008.172.012.345.012.519 0 5.307-4.04 11.428-11.429 11.428a11.37 11.37 0 01-6.157-1.804c.315.037.635.056.958.056a8.06 8.06 0 004.99-1.72 4.021 4.021 0 01-3.753-2.79 3.998 3.998 0 001.814-.069 4.018 4.018 0 01-3.223-3.937l.001-.051c.541.3 1.16.482 1.82.502a4.013 4.013 0 01-1.788-3.343c0-.736.199-1.426.544-2.02a11.404 11.404 0 008.28 4.197 4.018 4.018 0 016.845-3.663 8.057 8.057 0 002.55-.975 4.032 4.032 0 01-1.767 2.222 8.011 8.011 0 002.307-.633 8.163 8.163 0 01-2.004 2.08z"
});

var SvgTwitter = function SvgTwitter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 35 35",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter.625a2aad.svg";
export { ForwardRef as ReactComponent };